import { Component, OnInit, OnDestroy, TemplateRef, ViewContainerRef, AfterViewInit } from '@angular/core';
import { ManageService } from '../../../services/manage.service';
import { CommonService } from '../../../services';
import { Router, ActivatedRoute } from '@angular/router';
import { combineLatest, EMPTY, of, Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { TransitionEligibility, TransitionType } from '../../../models/transitionEligibility.mode';
import { CancelContent, CSPModifySubscriptionViewModel, GetCSPSubscription, MCEUpgradeModel, ProductTerm, RefundableDetails, RefundableQuantity, ScheduledNextTermInstructions, CSPModifySubscriptionResponse, CSPSubscriptions, SupportedBillingCycle, SubscriptionAction, GetProductPricingV2 } from '../../../models/csp.model';
import { ConfirmNCESubscriptionComponent } from '../../../popup-collection/confirm-nce-subscription/confirm-nce-subscription.component';
import { format } from 'date-fns';
import { AbstractControl, FormBuilder } from '@angular/forms';
import { MnpIdAipiResponse } from '../../../models/api-response.model';
import { ConfirmSubscriptionComponent } from '../../../popup-collection/confirm-subscription/confirm-subscription.component';
import { FinishSubscriptionComponent } from '../../../popup-collection/finish-subscription/finish-subscription.component';
import { ConfirmNCEQtyComponent } from '../../../popup-collection/confirm-nce-qty/confirm-nce-qty.component';
import { MatDialog } from '@angular/material/dialog';
import { PanelService } from '../../../services/panel.service';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { CurrentUserModel } from '../../../models/account-ledger.model';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-manage-license-subscription',
  templateUrl: './manage-license-subscription.component.html',
  styleUrls: ['./manage-license-subscription.component.css'],
  providers: [DatePipe, TitleCasePipe]
})

export class ManageLicenseSubscriptionComponent implements OnInit, OnDestroy, AfterViewInit {
  public customEndDateTypeList = [
    'No Change',
    'Co-Term',
    'Align Calendar Month'
  ];
  public renewalIsToday = false;
  loadContent = false;
  tenantId: string;
  subscriptionId: string;
  searchUpgrade: string;
  offerId: string;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  title = 'Manage Subscription';
  private transitionEligibilities: TransitionEligibility[] = [];
  private transitionEligibilitiesScheduled: TransitionEligibility[] = [];

  public transitionEligibilitiesDisplay: TransitionEligibility[] = [];
  public transitionEligibilitiesScheduledDisplay: TransitionEligibility[] = [];
  mpnList: string[] = [];
  NoMPNText = '';
  public from: GetCSPSubscription = {} as GetCSPSubscription;
  public currentProductPricingV2: GetProductPricingV2 = {} as GetProductPricingV2;
  public nceRenewalPending: SubscriptionAction;
  stockCode: string[] = [];
  billingFrequencyList: SupportedBillingCycle[];
  billingCycle: string;
  termDuration: string;
  selectedTermDuration: string;
  selectedBillingFrequency: string = '';
  // loading flag group
  autoRenewLoading = false;
  renewalLoading = true;
  billingLoading = false;
  qtyLoading = false;
  customEndDateLoading = false;
  public loadingSKUStatus = false;

  isBillingFreq: boolean = true;

  editMpn: boolean = false;

  editDesc: boolean = false;

  isSoftwareOrRI = false;

  isRenewLoaded = false;

  subscriptionDetailChanged = false;

  qtyChanged = false;

  termChanged = false;

  billingFreqChanged = false;

  updateQtyChange = false;

  customEndDateChanged = false;

  targetTerm: string;

  targetBillingFreq: string;

  cancellationAllowedUntilDate: Date;
  creationDate: string;

  qty: number;
  // originalTermDuration: string;
  expiryDate: string;
  currentUser: CurrentUserModel;
  isCancelable: boolean = false;
  isRefundable: boolean = false;
  isCanceling: boolean = false;

  poReference = '';
  mceRenewalData: MCEUpgradeModel = {} as MCEUpgradeModel;
  catalogItemId = '';
  supportedBillingCycles: string[] = [];
  billingCycleList: string[] = [];
  cancellationContent: CancelContent = { totalQuantity: 0, details: [] };
  refundableQuantity: RefundableQuantity = { totalQuantity: 0, details: [] };
  public scheduledNextTermInstructions: ScheduledNextTermInstructions;

  public loadingTransitionEligibilities = false;
  public loadingTransitionEligibilitiesScheduled = false;
  public transitionEligibilitiesLoaded = false;
  public transitionEligibilitiesScheduledLoaded = false;

  public subsForViewEndDates: CSPSubscriptions[];
  public subsForViewEndDatesBackUp: CSPSubscriptions[];

  public upgradeSubscriptionForm = this.fb.group({
    mpn: [{ value: '', disabled: false }],
    desc: [{ value: '', disabled: false }],
    autoRenewalEnabled: [{ value: false, disabled: true }],
    toQty: [''],
    renewal: [{ value: '', disabled: true }],
    billing: [''],
    activeSuspend: [false],
    customEndDate: [],
    customEndDateTypeControl: ['No Change']
  });

  public get toggleSuspendButton(): AbstractControl {
    return this.upgradeSubscriptionForm.get('activeSuspend')
  }

  public get TransitionType(): typeof TransitionType {
    return TransitionType; 
  }

  constructor(
    private manageService: ManageService,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    public cs: CommonService,
    private router: Router,
    private fb: FormBuilder,
    public sidenavService: PanelService,
    private vcr: ViewContainerRef,
    public calendar: NgbCalendar,
    private authService: AuthService,
    private datePipe: DatePipe,
    private titleCasePipe: TitleCasePipe
  ) {
    this.NoMPNText = cs.NoMPNText;
  }

  async ngAfterViewInit() {
    await this.cs.waitForElm('#levelOne');
    if (!$('#confirmUpgrade').length) {
      $('#levelOne').animate({ scrollLeft: $('#managecsp').width() + 505 }, 400);
    }
  }

  ngOnInit() {
    this.activatedRoute.url.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      setTimeout(() => {
        this.ngAfterViewInit();
      }, 100)
    });

    combineLatest([
      this.activatedRoute?.parent.params,
      this.activatedRoute?.params,
      this.activatedRoute?.firstChild?.params || of({}),
      this.manageService.currentExistingCSPSubscriptions,
      this.manageService.getCurrentNCERenewalPendingList
    ])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(([
        parentParams,
        params, 
        firstChildParams,
        subs,
        nceRenewalPendingList
      ]) => {

        this.tenantId = parentParams['tenantId'];
        this.subscriptionId = params['sub'];
        this.catalogItemId = firstChildParams['catalogItemId'];
        this.nceRenewalPending = nceRenewalPendingList.find(s => s.subscriptionId?.toLocaleLowerCase() == this.subscriptionId?.toLocaleLowerCase());
        
        if (subs && subs.length) {
          this.subsForViewEndDates = subs.filter(s => s.baseSubscription.out_charge_type === 'NCE' && (new Date(s.baseSubscription.out_expiry_date) > new Date()));
          if (this.subsForViewEndDates?.length <= 0) {
            const index = this.customEndDateTypeList.indexOf('Co-Term');
            if (index !== -1) {
              this.customEndDateTypeList.splice(index, 1);
            }
          }
        }
       
        // if we have catalogId stored we need to fetch transitionEligibles from Microsoft for other component's display
        if (this.catalogItemId) {
          if (
            !this.transitionEligibilitiesLoaded &&
            !this.loadingTransitionEligibilities
          ) {
            this.getTransitionEligibilities();
          }
        }

        // SUBSCRIPTION DETAILS
        if (params['sof'] != null) {
          this.isSoftwareOrRI = true;
          if (subs?.length) {
            this.manageService._softwareTabClick$.next(true);
          }

        } else if (subs != null && params['sub'] != null) {
          let sub: any = subs.find(s => s.baseSubscription.out_subscription_id == params['sub']);

          let isAddon = false;
          if (!sub) {
            const addons = subs.reduce((accumulator, currentValue) => [...accumulator, ...currentValue.addOnSubscription], []);
            sub = addons.find(s => s.out_subscription_id == params['sub']) as GetCSPSubscription;
            if (sub) isAddon = true
          }

          if (sub) {
            this.from = isAddon ? sub : sub?.baseSubscription;
            this.mceRenewalData.from = sub?.baseSubscription;
            
            this.upgradeSubscriptionForm.get('mpn').setValue(this.from?.out_mpnid == '' ? this.NoMPNText : this.from.out_mpnid);            
            this.upgradeSubscriptionForm.get('desc').setValue(this.from?.out_sub_description);
            this.toggleSuspendButton.setValue(!this.from?.out_activeSuspend);
            this.manageService.monitorMCESubscriptionUpgrade(this.mceRenewalData);
          }

        // MANAGE RENEWAL
        if (this.subscriptionId) {
          this.manageService.GetNCERenewStatus(this.tenantId.toLocaleLowerCase(), this.subscriptionId.toLocaleLowerCase())
            .pipe(takeUntil(this.ngUnsubscribe)).subscribe((sub: any) => {
              const result = JSON.parse(sub);
              if (!this.cs.isEmpty(result)) {
                this.displaySubDetailFromData(result);
                this.generateCancellationContent(result);
                this.offerId = result.offerId;
              }
            }, (error: any) => {
              this.cs.implementToast(error, 'Error');
            })
        }

        // Getting subscription's sku status
        if (this.from?.out_stock_code) {
          this.loadingSKUStatus = true;
          this.manageService.GetProductPricingList([this.from?.out_stock_code], 'Y')
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
            next: (res: GetProductPricingV2[]) => {
              this.currentProductPricingV2 = res[0]
              this.manageService.currentProductPricingV2 = this.currentProductPricingV2
              if (
                this.catalogItemId &&
                this.currentProductPricingV2?.out_condition == 'T' &&
                !this.transitionEligibilitiesScheduledLoaded &&
                !this.loadingTransitionEligibilitiesScheduled
              ) {
                this.renewalPaths();
              }
            },
            error: (error: string) => console.info(error),
            complete: () => this.loadingSKUStatus = false
          });
        }
        }

          this.manageService.currentSoftwareSubscription
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((subData: any) => {
              if (!this.cs.isEmpty(subData)) {       
                this.supportedBillingCycles = subData.supportedBillingCycles;
                let sub = subData;
                this.displaySubDetailFromData(sub);
                this.from.out_subscription_id = sub.id;
                this.from.out_expiry_date = sub.commitmentEndDate;
                this.from.out_confirmed_qty = sub.quantity;
                this.from.out_offer_uri = `${sub.termDuration}:${sub.stockCode}`;
                this.from.out_stock_code = `${sub.termDuration}:${sub.stockCode}`;
                this.upgradeSubscriptionForm.get('toQty').setValue(Number(this.from.out_confirmed_qty));
              }
          });


        this.authService.getLoginInfo().pipe(takeUntil(this.ngUnsubscribe)).subscribe(
          (user: CurrentUserModel) => {
            this.currentUser = user;
          }
        );

      });



    // this.selectedBillingFrequency = "No Change";
    // observe current subscription





    this.manageService.currentMPNList
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((mpns) => {
        this.mpnList = mpns;
      })  
  }

  private setupBillingFrequencySubscription(): void {
    this.upgradeSubscriptionForm.get('billing').valueChanges
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((term) => {
        if (term) {
          this.billingFreqChanged = this.billingCycle !== term;
          this.targetBillingFreq = term;
        } else {
          this.billingFreqChanged = false;
        }
      })
  }

  public isScheduleChanege(): boolean {
    return this.nceRenewalPending != null || this.scheduledNextTermInstructions != null;
  }

  private setupTermSubscription(): void {
    this.upgradeSubscriptionForm.get('renewal').valueChanges
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((term) => {
        this.termChanged = (term && this.getCurrentTerm() !== term)
        const [termrenewal, productId, skuId, billingId, promo] = this.from.out_stock_code?.split(":");
        const targetStockCode = [(term ? term : termrenewal), productId, skuId, billingId, promo].join(":");
        if (this.isRenewLoaded) this.loadBillingFrequency(this.tenantId, [targetStockCode]);
        if (this.upgradeSubscriptionForm.get('customEndDateTypeControl').value == 'Align Calendar Month') {
          this.changeEndDate('Align Calendar Month')
        }

        if (term == 'P1Y') {
          this.subsForViewEndDatesBackUp = [...this.subsForViewEndDates];
          const oneMonthLater = new Date();
          oneMonthLater.setMonth(oneMonthLater.getMonth() + 1);
          this.subsForViewEndDates = this.subsForViewEndDatesBackUp.filter(s => s.baseSubscription.out_charge_type === 'NCE' && (new Date(s.baseSubscription.out_expiry_date) > oneMonthLater));
        } else {
          if (this.subsForViewEndDatesBackUp?.length) {
            this.subsForViewEndDates = [...this.subsForViewEndDatesBackUp];
          }
        }
      })
  }

  private loadBillingFrequency(tenantId: string, sotckCodes: string[]): void {
    this.isBillingFreq = true;
    this.manageService
      .GetSupportedBillingCycleType(tenantId, sotckCodes)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (billingFrequencyList: SupportedBillingCycle[]) => {
          if (billingFrequencyList?.length) {
            this.billingCycleList = billingFrequencyList[0].supportedBillingCycleTypes;

            // remove the option that is currently at 
            const index = this.billingCycleList.indexOf(this.titleCasePipe.transform(this.billingCycle));
            if (index > -1) {
              this.billingCycleList.splice(index, 1);
            }
            
          }
          if (!this.isScheduleChanege() || !this.billingCycleList.includes(this.titleCasePipe.transform(this.scheduledNextTermInstructions?.product?.billingCycle))) {
            this.upgradeSubscriptionForm.get('billing').setValue('');
            this.billingFreqChanged = false;
          }
        },
        error: (error: string) => this.cs.implementToast(error, "Error"),
        complete: () => this.isBillingFreq = false
      });
  }

  toggleMPNChange() {
    this.editMpn = !this.editMpn;
  }

  toggleDescChange() {
    this.editDesc = !this.editDesc;
  }

  updateSubscriptionDetails() {
    this.confirmChange();
  }

  generateCancellationContent(sub: any) {
    if (sub.refundableQuantity) {
      this.cancellationContent.totalQuantity = sub.refundableQuantity.totalQuantity;
      this.cancellationContent.details = sub.refundableQuantity.details.map((val: any) => {
        return `Quantity: ${val.quantity} - allowed until: ${format(new Date(val.allowedUntilDateTime), 'dd-MMM-yyyy HH:mm')}`
      })
    }
  }

  displaySubDetailFromData(sub: any) {
    this.isRenewLoaded = true;
    this.refundableQuantity = sub.refundableQuantity;
    this.scheduledNextTermInstructions = sub.scheduledNextTermInstructions;
    this.mceRenewalData.autoRenewalEnabled = sub.autoRenewEnabled;
    this.upgradeSubscriptionForm.get('autoRenewalEnabled').setValue(this.mceRenewalData.autoRenewalEnabled)
    this.billingCycle = this.mceRenewalData.billingCycle = sub.billingCycle;
    this.termDuration = this.mceRenewalData.termDuration = sub.termDuration;


    this.cancellationAllowedUntilDate = new Date(sub.cancellationAllowedUntilDate);
    this.qty = sub.quantity;
    this.upgradeSubscriptionForm.get('toQty').setValue(Number((this.isScheduleChanege())? this.scheduledNextTermInstructions?.quantity : this.qty));
    this.mceRenewalData.changeToQty = Number(this.qty);
    this.mceRenewalData.commitmentEndDate = sub.commitmentEndDate;
    this.mceRenewalData.offerId = sub.offerId;
    this.expiryDate = sub.commitmentEndDate;
    this.creationDate = sub.creationDate;
    let today = new Date();
    // this.isCancelable = new Date(this.cancellationAllowedUntilDate) > today && (!this.cs.isEmpty(sub.refundOptions) && sub.refundOptions[0].type == 'Full')
    this.isCancelable = this.cancellationAllowedUntilDate > today;
    this.manageService.monitorMCESubscriptionUpgrade(this.mceRenewalData);

    const customEndDate = new Date(sub.commitmentEndDate)
    const date = { day: customEndDate.getUTCDate(), month: customEndDate.getUTCMonth() + 1, year: customEndDate.getUTCFullYear() };


    if (this.isScheduleChanege()) {
      if (this.getCurrentTerm() != this.scheduledNextTermInstructions?.product?.termDuration) {
        this.upgradeSubscriptionForm.get('renewal').setValue(this.scheduledNextTermInstructions?.product?.termDuration);
        this.termChanged = true;
      }
      this.upgradeSubscriptionForm.get('billing').setValue(this.cs.CSPBFMapping(this.titleCasePipe.transform(this.scheduledNextTermInstructions?.product?.billingCycle)));
      this.billingFreqChanged = this.termChanged = true;
    } else {
      this.upgradeSubscriptionForm.get('renewal').setValue('');
    }
    this.renewalLoading = false;
    this.setupTermSubscription();
    this.setupBillingFrequencySubscription();
  }

  isBillingFrequencyAllowed(billingFrequency) {
    return !(this.selectedTermDuration === 'Monthly' && billingFrequency === 'Annual');
  }

  confirmChange(): void {

    const dialogRef = this.dialog.open(ConfirmNCESubscriptionComponent, {
      width: '650px',
      data: { title: "Confirm Subscription Details", text: `Are you sure to change the subscription details` }
    });

    dialogRef.afterClosed().subscribe((res) => {

      if (res) {

        let confirmSubscriptions: CSPModifySubscriptionViewModel[] = [];

        let confirmBaseSubscription = {} as CSPModifySubscriptionViewModel;

        confirmBaseSubscription = {
          tenantId: this.from.out_tenant_id,
          //mpnId: this.upgradeSubscriptionForm.get('mpn').value == this.NoMPNText ? '' : this.upgradeSubscriptionForm.get('mpn').value,
          //pass NOMPNID when No Direct Reseller option selected
          mpnId: this.upgradeSubscriptionForm.get('mpn').value == this.NoMPNText ? "NOMPNID" : this.upgradeSubscriptionForm.get('mpn').value,
          subscriptionId: this.from.out_subscription_id,
          subscriptionDescription: this.upgradeSubscriptionForm.get('desc').value,
          customerReference: this.poReference,
          stockDescription: this.from.out_stk_description,
          parentSubscriptionId: this.from.out_parent_subscription,
          stockCode: this.from.out_stock_code,
          qty: this.from.out_qty,
          status: '',
          ownerEmail: this.from.out_default_email,
          price: this.from.out_price,
          totalPrice: this.from.out_amount,
          billingFrequency: this.from.out_billing_freq,
          chargeType: this.from.out_charge_type
        };

        confirmSubscriptions.push(confirmBaseSubscription);

        if ((this.upgradeSubscriptionForm.get('mpn').value == this.NoMPNText) || (this.upgradeSubscriptionForm.get('mpn').value == this.from.out_mpnid)) {

          this.editMpn = this.editDesc = true;

          this.upgradeSubscriptionForm.get('desc').disable();

          const dialogRef = this.dialog.open(ConfirmSubscriptionComponent, {
            width: '650px',
            data: { totalPriceChange: 0, pendingTotal: 0, hasNCE: true }
          });

          dialogRef.afterClosed().subscribe(result => {

            if (result) {
              this.poReference = result;
              this.manageService.createOrUpdateCSPSubscription(confirmSubscriptions).subscribe((res: any) => {

                if (res?.status == false) {
                  this.cs.implementToast(res?.responseMessage, 'Error')
                } else {
                  // this.editMpn = false;
                  // this.manageService.refetchCSPItemsView$.next();
                  let finishSubscriptions = res;
                  this.loadContent = true;
                  const dialogRefFinish = this.dialog.open(FinishSubscriptionComponent, {
                    width: '650px',
                    data: { finishSubscriptions: finishSubscriptions },
                    disableClose: true
                  });

                  dialogRefFinish.afterClosed().subscribe(() => {
                    this.editMpn = this.editDesc = false;
                    this.upgradeSubscriptionForm.get('desc').enable();
                    this.upgradeSubscriptionForm.get('mpn').enable();
                    this.manageService.refetchCSPItemsView$.next();
                  })
                }
     
              });
            }
          })

        } else {

          this.editMpn = this.editDesc = true;

          this.upgradeSubscriptionForm.get('desc').disable();
          this.upgradeSubscriptionForm.get('mpn').disable();
          this.manageService.GetPartnerByMPNId(confirmBaseSubscription.mpnId).subscribe((res: MnpIdAipiResponse) => {
            if (res.result === 'Success') {
              this.cs.implementToast('Verifying Microsoft Partner Agreement Status ...', 'Info');
              this.manageService.GetMPAStatusByMPNId(confirmBaseSubscription.mpnId).subscribe((result: MnpIdAipiResponse) => {
                if (result.status === false) {
                  this.cs.implementToast('Please check Microsoft Partner Agreement status with partner_id ' + confirmBaseSubscription.mpnId, 'Error', true);
                  this.editMpn = false;

                } else {

                  const dialogRef = this.dialog.open(ConfirmSubscriptionComponent, {
                    width: '650px',
                    data: { totalPriceChange: 0, pendingTotal: 0, hasNCE: true }
                  });

                  dialogRef.afterClosed().subscribe(result => {

                    if (result) {
                      this.poReference = result;
                      this.manageService.createOrUpdateCSPSubscription(confirmSubscriptions).subscribe((res) => {
                        // this.editMpn = false;
                        // this.manageService.refetchCSPItemsView$.next();
                        let finishSubscriptions = res;
                        // this.loadContent = true;
                        const dialogRefFinish = this.dialog.open(FinishSubscriptionComponent, {
                          width: '650px',
                          data: { finishSubscriptions: finishSubscriptions },
                          disableClose: true
                        });

                        dialogRefFinish.afterClosed().subscribe(() => {
                          this.editMpn = this.editDesc = false;
                          this.upgradeSubscriptionForm.get('desc').enable();
                          this.upgradeSubscriptionForm.get('mpn').enable();
                          this.manageService.refetchCSPItemsView$.next();
                        })
                      });
                    } else {
                      this.upgradeSubscriptionForm.get('desc').enable();
                      this.upgradeSubscriptionForm.get('mpn').enable();
                    }
                  })
                }
              })
            } else {
              this.cs.implementToast('Invalid MPN ID', 'Error');
              this.editMpn = this.editDesc = false;
              this.upgradeSubscriptionForm.get('desc').enable();
              this.upgradeSubscriptionForm.get('mpn').enable();
            }
          });
        }
      }
    });
  }

  showAutoCompletePanel(trigger: any): void {
    trigger.openPanel();
  }

  getRenewDate() {
    let renew_date = '';
    if (this.expiryDate) {
      let renewalDate = new Date(this.expiryDate);
      renewalDate.setDate(renewalDate.getDate() + 1);

      // Get today's date
      const todaysDate = new Date();

      // call setHours to take the time out of the comparison
      if (renewalDate.setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0)) {
        this.renewalIsToday = true;
      }
      renew_date = format(renewalDate, 'dd-MMM-yyyy');
    }
    return renew_date.toUpperCase();
  }

  getCurrentTerm(): string {
    return this.from?.out_target_term || this.from?.out_stock_code?.split(":")[0]?.toUpperCase();
  }

  getAutoRenwewalText(autoRenewalEnabled: boolean): string {
    if (autoRenewalEnabled) {
      let renewalDate = new Date(this.expiryDate);
      renewalDate.setDate(renewalDate.getDate() + 1);
      return `RENEWS ON ${format(renewalDate, 'dd-MMM-yyyy')}`
    } else {
      return `EXPIRY ON ${format(new Date(this.expiryDate), 'dd-MMM-yyyy')}`
    }
  }

  isSubInProgress(): boolean {
    return !this.cs.isEmpty(this.from) && this.from.out_status_desc && this.from.out_status_desc.includes('In Progress')
  }
  onQtyTyping(event: any) {
    if (event.key < 0 && event.target.value == "") {
      event.preventDefault();
    }
  }
  formatDateTime(vdate: any) {
    return format(new Date(vdate), 'dd-MMM-yyyy HH:mm');
  }
  checkCancelable(qty: number): boolean {
    let remainQty = this.qty - qty;

    if (remainQty > this.refundableQuantity.totalQuantity) {
      this.isRefundable = false;
      return false;
    }
    this.isRefundable = true;
    return true;
  }

  updateQty() {

    let targetQty = this.upgradeSubscriptionForm.get('toQty').value
    let currenAmount: number;
    let additionalAmount: number;
    let nextBillingAmount: number;
    this.qtyChanged = Number(targetQty) !== Number(this.qty);
    if (this.upgradeSubscriptionForm.get('toQty').value) {
      if (this.qtyChanged && (this.upgradeSubscriptionForm.get('autoRenewalEnabled').value || (targetQty > this.qty) || this.checkCancelable(targetQty))) {
        currenAmount = (Number(this.from.out_price) * this.qty);
        let term
        let totalDaysInCurrentTerm = 0;
        if (this.termDuration == 'P1Y') {
          totalDaysInCurrentTerm = 365;
        }
        else if (this.termDuration == 'P3Y') {
          totalDaysInCurrentTerm = 365 * 3;
        }
        else if (this.termDuration == 'P6Y') {
          totalDaysInCurrentTerm = 365 * 6;
        }
        else if (this.termDuration = 'P1M') {
          totalDaysInCurrentTerm = this.cs.getNumnerOfDaysInCurrentMonth();
        }



        let remainingDays = this.cs.getDateDiffInDays(new Date(), new Date(this.expiryDate));
        let additionalOrRefundLabel: string;
        let additionalQty = targetQty - this.qty;
        let additionalAmount = (remainingDays / totalDaysInCurrentTerm) * additionalQty * Number(this.from.out_price);
        let newTermAmount = (Number(this.from.out_price) * targetQty);

        // for yearly skus, no need to add current amount with additional charges if occuring after the purchased month
        if (this.termDuration.includes('Y')) {
          var changesInSameMonth = this.cs.IsDatesInSameMonth(new Date(), new Date(this.creationDate));
          if (changesInSameMonth) {
            nextBillingAmount = currenAmount + additionalAmount;
          }
          else {
            nextBillingAmount = additionalAmount;
          }
        }
        else {
          nextBillingAmount = currenAmount + additionalAmount;
        }

        if (additionalQty > 0) {
          additionalOrRefundLabel = "Estimated additional prorated charges";
        }
        else {
          additionalOrRefundLabel = "Refunds prorated";
        }
        if (!this.cs.isEmpty(this.refundableQuantity) && !this.checkCancelable(targetQty)) {
          return;
        }

        if (Number(targetQty) > Number(this.qty) || this.isRefundable) {
          //show popup
          const dialogRef = this.dialog.open(ConfirmNCEQtyComponent, {
            width: '650px',
            data: {
              additionalOrRefundLabel,
              currenAmount,
              additionalAmount,
              nextBillingAmount,
              newTermAmount,
              autorenew: this.upgradeSubscriptionForm.get('autoRenewalEnabled').value
            }
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result != undefined && result.action == 'ScheduleNew') {
              this.updateRenewal();
            }
            if (result != undefined && result.action == 'Immediately') {
              this.autoRenewLoading = true;
              this.manageService.UpdateNCERenewalQty(this.tenantId, this.from.out_subscription_id.toLowerCase(), this.from.out_stock_code.toLocaleLowerCase(), this.from.out_offer_uri.toLocaleLowerCase(), targetQty, "QUANTITY", this.from.out_expiry_date).subscribe(() => {
                this.autoRenewLoading = false;
                this.manageService.refetchCSPItemsView$.next();
              },
                (error) => {
                  this.autoRenewLoading = false;
                  this.upgradeSubscriptionForm.get('toQty').setValue(Number(this.qty));
                  this.cs.implementToast(error, "Error");
                });
              return;
            }
            if (result != undefined && result.action == 'Close') {
              this.upgradeSubscriptionForm.get('toQty').setValue(Number(this.qty));
              this.qtyChanged = false;
              return;
            }
          })
        }
      } else if (!this.upgradeSubscriptionForm.get('autoRenewalEnabled').value && (targetQty < this.qty)) {
        this.upgradeSubscriptionForm.get('toQty').setValue(Number(this.qty));
        this.cs.implementToast(`Qty must be greater than ${this.qty}`, 'Error');
      }
    } else {
      this.upgradeSubscriptionForm.get('toQty').setValue(Number(this.qty));
      this.cs.implementToast('Zero quantity is not allowed', 'Error');
    }


  }

  async updateRenewal() {
    
    let scheduleChange :any ;
    let title: string = 'Confirm Renewal Update';
    let text: string = "";

    let billing: number;
    let customEndDate: string;
    scheduleChange =  this.scheduledNextTermInstructions ;
    if (this.customEndDateChanged) {
      const date = new Date(
        this.upgradeSubscriptionForm.get('customEndDate').value.year,
        this.upgradeSubscriptionForm.get('customEndDate').value.month - 1,
        this.upgradeSubscriptionForm.get('customEndDate').value.day
      )
      customEndDate = this.datePipe.transform(date, 'yyyy-MM-dd')
      text = `Change subscription custom end date to ${customEndDate}`;
    }

    if (this.termChanged) {
      if (text.length > 0) {
        text += ', ';
      }
      text += `Change subscription renewal to ${this.cs.CSPTermMapping(this.upgradeSubscriptionForm.get('renewal').value || this.from?.out_stock_code?.split(":")[0].toUpperCase() )}`;
    }
    if (this.billingFreqChanged) {
      if (text.length > 0) {
        text += ', ';
      }
      text += ` Are you sure you want to change the billing plan from ${this.titleCasePipe.transform(this.billingCycle)} to ${this.cs.CSPBFMapping(this.upgradeSubscriptionForm.get('billing').value)}`;
    }
    if (this.qtyChanged) {
      if (text.length > 0) {
        text += ', ';
      }
      text += `Quantity from ${this.qty} to ${this.upgradeSubscriptionForm.get('toQty').value}`;
    }
    if (text === '') {
      text = "This action will schedule the same current options on next renewal. Are you sure to continue?";
    }
    else {
      text += '?';
    }
    if (this.termChanged) {
      let [term, productId, skuId, billingId, promotion] = this.from.out_stock_code.split(':');

      let targetStockCode: string;

      if (this.upgradeSubscriptionForm.get('renewal').value) {
        term = this.upgradeSubscriptionForm.get('renewal').value;
      }
      if (this.upgradeSubscriptionForm.get('billing').value) {
        billingId = this.upgradeSubscriptionForm.get('billing').value;
      }
      targetStockCode = [term, productId, skuId, billingId, promotion].join(':');

      const response = await fetch('Manage/GetProductPricingList', {
        method: 'POST', // or 'PUT'
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify([targetStockCode]),
      });

      let stockPriceList = await response.json();

      billing = (Number(stockPriceList[0].out_current_price) * this.upgradeSubscriptionForm.get('toQty').value);
    }
    else if (this.qtyChanged) {
      billing = (Number(this.from.out_price) * this.upgradeSubscriptionForm.get('toQty').value);
    }

    const dialogRef = this.dialog.open(ConfirmNCESubscriptionComponent, {
      width: '650px',
      data: { title, text, billing, scheduleChange}
    });

    dialogRef.afterClosed().subscribe(result => {

      // Triennial =5 Monthly=1  Annual=2
      if (result) {

        let productTerm = {} as ProductTerm;

        let [term, productId, skuId] = this.from.out_stock_code.split(':');

        productTerm.productId = productId;

        productTerm.skuId = skuId;

        productTerm.termDuration = this.upgradeSubscriptionForm.get('renewal').value || this.termDuration;

        let billingFreqStr = this.cs.CSPBFMapping(this.upgradeSubscriptionForm.get('billing').value) || this.billingCycle;

        productTerm.billingCycle = this.cs.parseToBillingCyleType(billingFreqStr);

        //productTerm.availabilityId = '';

        productTerm.availabilityId = this.offerId;

        let targetQty = this.qtyChanged ? this.upgradeSubscriptionForm.get('toQty').value : Number(this.qty);

        if (this.qtyChanged) {
          this.qtyLoading = true;
        }
        if (this.termChanged) {
          this.renewalLoading = true;
        }
        if (this.billingFreqChanged) {
          this.billingLoading = true;
        }
        if (this.customEndDateChanged) {
          this.customEndDateLoading = true
        }

        this.manageService.UpdateSubscriptionCycle(
          this.tenantId,
          this.from.out_subscription_id.toLowerCase(),
          this.from.out_stock_code.toLocaleLowerCase(),
          this.from.out_offer_uri.toLocaleLowerCase(),
          targetQty,
          'RENEWAL',
          this.from.out_expiry_date,
          productTerm,
          customEndDate ? customEndDate + ' 23:59:00' : null
        ).subscribe((res: any) => {
          if (res?.status == false) {
            this.cs.implementToast(res?.responseMessage, 'Error')
          } 
          this.manageService.refetchCSPItemsView$.next();
          this.renewalLoading = this.billingLoading = this.qtyLoading = this.customEndDateLoading = false;
        },
          (error) => {
            this.renewalLoading = this.billingLoading = this.qtyLoading = this.customEndDateLoading = false;
          }
        );
      }
    })
  }

  async UpdateSubscriptionCycle(termDuration: string, subscription: GetCSPSubscription, action: string) {
    let title, text: string;
    let billing: number;

    if (action == 'RENEWAL') {
      title = 'Confirm Renewal';
      if (termDuration == 'P1Y') {
        text = 'Are you sure to change the subscription renewal to annually?';
      } else {
        text = 'Are you sure to change the subscription renewal to monthly?';
      }

      //get billing
      const [term, productId, skuId, billingId, promotion] = subscription.out_stock_code.split(':');

      let targetStockCode: string;

      if (term == 'P1Y') {
        targetStockCode = ["P1M", productId, skuId, billingId, promotion].join(':');
      } else if (term == 'P1M') {
        targetStockCode = ["P1Y", productId, skuId, billingId, promotion].join(':');
      }

      const response = await fetch('Manage/GetProductPricingList', {
        method: 'POST', // or 'PUT'
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify([targetStockCode]),
      });

      let stockPriceList = await response.json();


      billing = Number(stockPriceList[0].out_current_price) + Number(subscription.out_price);

    } else if (action == 'BILLING') {
      title = 'Confirm Billing Plan';
      if (termDuration == 'P1Y') {
        text = 'Are you sure to change the subscription billing plan to annually?';
      } else {
        text = 'Are you sure to change the subscription billing plan to monthly?';
      }
    }

    const dialogRef = this.dialog.open(ConfirmNCESubscriptionComponent, {
      width: '650px',
      data: { title, text, billing }
    });

    dialogRef.afterClosed().subscribe(result => {
      // Triennial =5 Monthly=1  Annual=2
      if (result) {

        let productTerm = {} as ProductTerm;

        let [term, productId, skuId] = subscription.out_stock_code.split(':');

        productTerm.productId = productId;

        productTerm.skuId = skuId;

        if (action == 'RENEWAL') {

          productTerm.termDuration = termDuration;

          productTerm.billingCycle = term == 'P1Y' ? 2 : 1;

        } else if (action == 'BILLING') {

          productTerm.termDuration = term;

          productTerm.billingCycle = termDuration == 'P1Y' ? 2 : 1;

        }


        productTerm.availabilityId = this.offerId;

        if (action == 'RENEWAL') {
          this.renewalLoading = true;
        } else {
          this.billingLoading = true;
        }

        this.manageService.UpdateSubscriptionCycle(this.tenantId, subscription.out_subscription_id.toLowerCase(), subscription.out_stock_code.toLocaleLowerCase(), subscription.out_offer_uri.toLocaleLowerCase(), Number(subscription.out_confirmed_qty), action, subscription.out_expiry_date, productTerm).subscribe(() => {
          this.manageService.refetchCSPItemsView$.next();
          this.renewalLoading = this.billingLoading = false;
        },
          (error) => {
            this.cs.implementToast(error, "Error");
            this.renewalLoading = this.billingLoading = false;

          });
      } else {
        if (action == 'RENEWAL') {
          this.upgradeSubscriptionForm.get('renewal').setValue('');
        } else if (action == 'BILLING') {
          this.upgradeSubscriptionForm.get('billing').setValue('');
        }
      }
    });
  }

  toggleAutoRenew(event: any, subscription: GetCSPSubscription) {
    if (this.autoRenewLoading || !this.isRenewLoaded) {
      return;
    }
    let action = this.upgradeSubscriptionForm.get('autoRenewalEnabled').value !== true ? 'off' : 'on';

    const dialogRef = this.dialog.open(ConfirmNCESubscriptionComponent, {
      width: '650px',
      data: { title: 'Confirm Auto-Renew Change', text: `Are you sure you want to turn ${action} Auto-renew?` }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.autoRenewLoading = true;
        this.manageService.UpdateSubscriptionRenew(
          this.tenantId.toLocaleLowerCase(),
          subscription.out_subscription_id.toLocaleLowerCase(),
          subscription.out_stock_code.toLocaleLowerCase(),
          this.upgradeSubscriptionForm.get('autoRenewalEnabled').value,
          subscription.out_expiry_date
        ).subscribe(
          () => {
            this.cs.implementToast(`Auto-renew has been turned ${action} successfully`, "Success");
          },
          (error: any) => {
            this.cs.implementToast(error, "Error")
            this.upgradeSubscriptionForm.get('autoRenewalEnabled').setValue(!this.upgradeSubscriptionForm.get('autoRenewalEnabled').value);
          }
        ).add(() => {
          this.autoRenewLoading = false;
        });
      } else {
        this.upgradeSubscriptionForm.get('autoRenewalEnabled').setValue(!this.upgradeSubscriptionForm.get('autoRenewalEnabled').value);
      }
    });
  }

  confirmTransition(transition: TransitionEligibility, transitionType: string) {
    this.mceRenewalData.to = transition;
    this.manageService.monitorMCESubscriptionUpgrade(this.mceRenewalData);
    if (transitionType == TransitionType.TRANSITION_ONLY) {
      this.router.navigate([`ConfirmUpgrade/${transition.catalogItemId}`], { relativeTo: this.activatedRoute });
    } else if (transitionType == TransitionType.TRANSITION_WITH_LICENSE_TRANSFER) {
      this.router.navigate([`ConfirmRenewal/${transition.catalogItemId}`], { relativeTo: this.activatedRoute });
    }
  }

  filterUpgrade() {
    this.transitionEligibilitiesDisplay = this.transitionEligibilities.filter((item) => item.catalogItemId.toLocaleLowerCase().includes(this.searchUpgrade) || item.title.toLocaleLowerCase().includes(this.searchUpgrade))
  }

  cancelSubscription(subscription: GetCSPSubscription) {
    this.dialog.open(ConfirmNCESubscriptionComponent, {
      width: '650px',
      data: {
        title: 'Confirm Cancellation', text: 'Are you sure to cancel this subscription?',
        cancelMessage: ' If you cancel the subscription within 7 days, you will be refunded for any time you have not used. A credit will appear in your next monthly invoice. The customer will lose access to this subscription immediately upon cancellation and access can’t be restored after cancellation.'
      }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.isCanceling = true;
        this.manageService.CancelSubscription(this.tenantId.toLocaleLowerCase(), subscription.out_subscription_id.toLocaleLowerCase(), subscription.out_stock_code.toLocaleLowerCase(), subscription.out_offer_uri.toLocaleLowerCase(), subscription.out_expiry_date ? subscription.out_expiry_date : '')
          .subscribe((res: any) => {
            this.isCanceling = false;

            if (res?.status == false) {
              this.cs.implementToast(res?.responseMessage, 'Error')
            } else {
              if (this.isSoftwareOrRI) {
                this.cs.implementToast('Successfully cancelled this software subscription, it may take few hours to get removed', 'Success')
                this.manageService.refetchSoftwareSubscription$.next();
              } else {
                this.manageService.refetchCSPItemsView$.next();
              }
              this.close();
            }
        },
          (error: any) => {
            this.isCanceling = false;
            this.cs.implementToast(error, "Error")
          });
      }
    });
  }

  public getTransitionEligibilities(): void {
    // UPGRADE OPTIONS
    if (this.subscriptionId) {
      this.loadingTransitionEligibilities = true;
      this.manageService.GetTransitionEligibilities(this.tenantId.toLocaleLowerCase(), this.subscriptionId.toLocaleLowerCase())
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((data: any) => {
          data.forEach(ele => {
            if (ele.eligibilities.some(eligibility => eligibility.isEligible == true)) {
              this.transitionEligibilities.push(ele);
            }
            if (ele.catalogItemId == this.catalogItemId) {
              this.mceRenewalData.to = ele;
              this.manageService.monitorMCESubscriptionUpgrade(this.mceRenewalData);
            }
          });
          this.transitionEligibilitiesDisplay = [ ...this.transitionEligibilities ];
          this.transitionEligibilitiesLoaded = true;
          this.loadingTransitionEligibilities = false;
        });
    }
  }

  public toggleSuspendHandler(): void {
    // prepare texts for popup display
    const status = this.toggleSuspendButton.value ? 'XX' : 'PR';
    const title = this.toggleSuspendButton.value ? "Confirm Suspension" : "Confirm Activate";
    const text = `This will ${this.toggleSuspendButton.value ? 'suspend' : 'activate'} service, you will continue to accrue charges as per this subscriptions existing commitment. Additional commitments will also accrue if auto-renew is still enabled`;

    if (this.toggleSuspendButton.value) {
      this.from.out_status_desc = 'Suspend Pending';
    }
    else {
      this.from.out_status_desc = 'Reactivation Pending';
    }
    // show confirm popup
    this.dialog.open(ConfirmNCESubscriptionComponent, {
      width: '650px',
      data: { title, text }
    })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          const confirmSub = {
            tenantId: this.from.out_tenant_id,
            mpnId: this.cs.parseNPM(this.from.editMpnIdValue),
            subscriptionId: this.from.out_subscription_id,
            subscriptionDescription: this.from.out_sub_description,
            customerReference: '',
            stockDescription: this.from.out_stk_description,
            parentSubscriptionId: this.from.out_parent_subscription,
            stockCode: this.from.out_stock_code,
            qty: this.from.out_qty,
            status,
            ownerEmail: this.from.out_default_email,
            price: this.from.out_price,
            totalPrice: this.from.out_amount,
            billingFrequency: this.from.out_billing_freq
          } as CSPModifySubscriptionViewModel;

          this.loadContent = false;
          this.manageService.createOrUpdateCSPSubscription([confirmSub]).subscribe((res: CSPModifySubscriptionResponse[]) => {
            if (res.length) {
              const finishSubscriptions = res;
              this.loadContent = true;
              const dialogRefFinish = this.dialog.open(FinishSubscriptionComponent, {
                width: '650px',
                data: { finishSubscriptions: finishSubscriptions },
                panelClass: 'mat-dialog-wrapper',
                disableClose: true
              });

              dialogRefFinish.afterClosed().subscribe(() => {
                this.manageService.refetchCSPItemsView$.next();
              }, (error: any) => {
                this.cs.implementToast(error, 'Error');
              }
              );
            }
          });
        } else {
          // if user cancel the popup window we need to set the toggle back
          this.toggleSuspendButton.setValue(!this.toggleSuspendButton.value)
          if (this.toggleSuspendButton.value) {
            this.from.out_status_desc = 'Suspended';
          }
          else {
            this.from.out_status_desc = 'Active';
          }
        }
      })
  }

  assignEndDate(date: string): void {
    const selectedDate = new Date(date);
    const originCustomEndDate = new Date(this.expiryDate);
    const originDay = originCustomEndDate.getDate();
    const originMonth = originCustomEndDate.getMonth() + 1;
    const originYear = originCustomEndDate.getFullYear();
    let dateToChange: any = null;
    if (originCustomEndDate > selectedDate) {
      // need to align it with next term co-term date
      let coTermDate = new Date();

      if (this.termDuration == "P1M") {
        coTermDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, selectedDate.getDate());
        if (originCustomEndDate > coTermDate) {
          coTermDate = new Date(coTermDate.setMonth(coTermDate.getDate() + 2));
        }
      }
      else if (this.termDuration == "P1Y") {
        coTermDate = new Date(selectedDate.getFullYear() + 1, selectedDate.getMonth(), selectedDate.getDate());
          if (originCustomEndDate > coTermDate) {
          coTermDate = new Date(coTermDate.setFullYear(coTermDate.getFullYear() + 1));
        }
      }
      else if (this.termDuration == "P3Y") {
        coTermDate = new Date(selectedDate.getFullYear() + 3, selectedDate.getMonth(), selectedDate.getDate());
        if (originCustomEndDate > coTermDate) {
          coTermDate = new Date(coTermDate.setFullYear(coTermDate.getFullYear() + 3));
        }
      }
      dateToChange = { day: coTermDate.getDate(), month: coTermDate.getMonth() + 1, year: coTermDate.getFullYear() };

    }
    else {
      dateToChange = { day: selectedDate.getDate(), month: selectedDate.getMonth() + 1, year: selectedDate.getFullYear() };
    }
    this.upgradeSubscriptionForm.get('customEndDate').setValue(dateToChange);
    this.cs.implementToast('Expiry date applied!', 'Success');
    if (originDay != dateToChange.day || originMonth != dateToChange.month || originYear != dateToChange.year) {
      this.customEndDateChanged = true;
    } else {
      this.customEndDateChanged = false;
    }
    this.sidenavService.panel.close()
  }

  changeEndDate(value, tempRef?: TemplateRef<any>) {
    let dateToChange = {}
    if (value == 'Align Calendar Month') {
      if (this.sidenavService?.panel?.opened) {
        this.sidenavService.panel.close()
      }

      /**
       * !!!!!!!!!!!
       * Date obj month starts from 0
       * DatePicker(UI) obj month starts from 1
       */
      const expDate = new Date(this.expiryDate);
      let year = expDate.getFullYear();
      let month = expDate.getMonth() + 1;
      let day = expDate.getDate();
      if (
        // change term from month to annual
        (
          this.upgradeSubscriptionForm.get('renewal').value === 'P1Y' && !this.termDuration.includes('P1Y')
        ) || 
        // was annual and no change in term
        (
          this.upgradeSubscriptionForm.get('renewal').value === '' && this.termDuration.includes('P1Y')
        )
      ) {
        year += 1;
        // error case: 30/10/2023
        // wrong: 31/10/2024   correct: 30/9/2024
        if (new Date(year, month, 0).getDate() > day) {
          if (month == 1) {
            month = 12;
            year -= 1;
          } else {
            month -= 1
          }
        }
      } else if (this.termDuration.includes('P3Y')) {
        year += 3;
      } else if (this.termDuration.includes('P1M')) {

        /**
         * https://learn.microsoft.com/en-us/partner-center/align-subscription-end-dates#one-month-term-subscription-example
         * 
         * The custom term end date must be within the first term duration, and for monthly term products,
         * it cannot align with a subscription ending on the 28th, 29th, or 30th of the month, unless that date is the last day of the month.
         * 
         */
        const endDay = expDate.getDate();
        // const lastDay = new Date(year,  month, 0).getDate();
        if (endDay >= 28) {
          month = month === 12 ? 1 : month + 1;
        }
      }

      day = new Date(year, month, 0).getDate();
      dateToChange = { year, month, day };

    } else if (value == 'Co-Term') {
      this.openRightPanel(tempRef)
    } else {
      if (this.sidenavService?.panel?.opened) {
        this.sidenavService.panel.close()
      }
    }

    if (!this.cs.isEmpty(dateToChange)) {
      this.upgradeSubscriptionForm.get('customEndDate').setValue(dateToChange);
      this.customEndDateChanged = true;
    } else {
      this.upgradeSubscriptionForm.get('customEndDate').setValue(null);
      this.customEndDateChanged = false;
    }
  }

  public showEndDateAligment(): boolean {
    const currentEndDate = new Date(this.expiryDate);
    const endDay = currentEndDate.getDate();
    return !(this.termDuration?.includes('P1M') && endDay >= 28)
  }

  public renewalPaths(): void {
    if (this.subscriptionId) {
      this.loadingTransitionEligibilitiesScheduled = true;
      this.manageService.GetTransitionEligibilities(this.tenantId.toLocaleLowerCase(), this.subscriptionId.toLocaleLowerCase(), true)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((data: any) => {
          data.forEach(ele => {
            if (ele.eligibilities.some(eligibility => eligibility.isEligible == true)) {
              this.transitionEligibilitiesScheduled.push(ele);
            }
            if (ele.catalogItemId == this.catalogItemId) {
              this.mceRenewalData.to = ele;
              this.manageService.monitorMCESubscriptionUpgrade(this.mceRenewalData);
            }
          });
          this.transitionEligibilitiesScheduledDisplay = [ ...this.transitionEligibilitiesScheduled ];
          this.transitionEligibilitiesScheduledLoaded = true;
          this.loadingTransitionEligibilitiesScheduled = false;
        });
    }
  }

  openRightPanel(tempRef: TemplateRef<any>) {
    if (this.sidenavService?.panel?.opened) {
      this.sidenavService.panel.close()
    } else {
      this.sidenavService.setViewContainerRef(this.vcr);
      this.sidenavService.setPanelContent(tempRef);
      this.sidenavService.open();
    }
  }

  close() {
    this.manageService.sendCurrentSoftwareSubscription(null);
    this.manageService.backToTenentPage(this.tenantId);
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  ngOnDestroy() {
    if (this.sidenavService?.panel?.opened) {
      this.sidenavService.panel.close();
    }
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
